module.exports = __webpack_public_path__ + "img/logoasociatia.243685ca.png";